import { createApiAction } from '@app/packages/api/utils'

export const postApprovalRequest = () =>
  createApiAction('postApprovalRequest', dispatch => dispatch<unknown>({ method: 'POST', endpoint: '/api/v2/approval_request' }))
